<nav aria-label="breadcrumb">
	<ol class="breadcrumb mb-0 pl-0">
		<li class="breadcrumb-item"><a href="/usuario-inicio">Mantenedor de usuario</a></li>
		<li class="breadcrumb-item active" aria-current="page"><a><strong>Crear</strong></a></li>
	</ol>
</nav>

<div class="row align-items-center">
	<a [routerLink]="'/usuario-inicio'">
		<button class="btn boton_volver" data-toggle="tooltip" data-placement="top" title="VOLVER" alt="VOLVER"><i
			class="bi bi-chevron-left mr-2"></i>Volver
		</button>
	</a>
	<h1 class="centrar_contenido offset-4">Crear usuario</h1>
</div>

<form [formGroup]="formularioBusqueda" (ngSubmit)="buscarUsuario()">
	<div class="d-flex align-items-end mt-5">
		<div class="col-3 pl-0">
			<div class="form-group mb-0">
				<label for="BuscarUsuario" class="titulo_criterios">Buscar usuario</label>
				<input formControlName="texto" type="text" class="form-control select_criterios" id="BuscarUsuario" placeholder="Ej: jperez">
			</div>
		</div>
		<div class="col-1 centrar_iconos_botones ml-3">
			<button [disabled]="formularioBusqueda.invalid" class="btn boton-buscar" data-toggle="tooltip" data-placement="top" title="BUSCAR" alt="BUSCAR"><i
				class="bi bi-search"></i>
			</button>
		</div>
	</div>

	<div class="p-0">
		<div *ngIf="textoBusqueda !== '' && formularioBusqueda.get('texto')?.invalid" class="alert alert-danger tipografía_alertas mt-4" role="alert">
			<i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> El campo debe contener mínimo 4 carácteres
		</div>
	</div>

	<div class="p-0">
		<div *ngIf="alertErrorTxt !== ''" class="alert alert-danger tipografía_alertas mt-4" role="alert">
			<i class="bi bi-x-circle tamanio_iconos-boton mr-2"></i> {{ alertErrorTxt }}
		</div>
	</div>

</form>
<!-- TABLA -->
<div style="margin-top: 30px;">
	<table *ngIf="renderTable" [dtOptions]="dtOptions" datatable class="row-border hover table-striped display nowrap " aria-describedby="tabla usuarios crear">
		<thead class="header_tabla">
			<tr>
				<th class="py-2">Usuario</th>
				<th class="py-2">Nombre</th>
				<th class="py-2">Primer apellido</th>
				<th class="py-2">Segundo apellido</th>
				<th class="py-2">Email</th>
				<th class="py-2">Acción</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let usuario of listaUsuarios">
				<td>{{ usuario.username }}</td>
				<td>{{ usuario.nombre }}</td>
				<td>{{ usuario.apellidoPaterno }}</td>
				<td>{{ usuario.apellidoMaterno }}</td>
				<td>{{ usuario.correo }}</td>
				<td>
					<button (click)="seleccionarRolSedeUsuario(usuario)" class="btn text-uppercase boton-accion_seleccionar" data-toggle="tooltip"
					data-placement="top" title="SELECCIONAR" alt="SELECCIONAR"> seleccionar<i
					class="bi bi-chevron-right pl-2"></i>
				</button>
			</td>
		</tr>
	</tbody>
</table>
</div>

<!-- FIN TABLA -->

<div class="mb-5 mt-5 centrar_contenido">
	<a href="/usuario-inicio">
		<button
		class="boton-secundario"
		data-toggle="tooltip"
		data-placement="top"
		title="CANCELAR"
		alt="CANCELAR">cancelar
	</button>
	</a>
</div>

<app-modal-info modalId="modal-info" [titulo]="infoModalTitulo" [texto]="infoModalTexto"></app-modal-info>
<button id="btn-modal-info" type="button" class="btn btn-primary d-none" data-toggle="modal" data-target="#modal-info">
  Launch demo modal
</button>